export const USER_PROFILE = {
    full_name: '',
    avatar: '',
    role: '',
    user_id: '',
    hh_agency_id: ''
};
